<script setup>
import {computed} from "vue";

const props = defineProps({
    dateTime: {
        type: Date,
        required: true
    },
    suffix: {
        type: String,
        required: false,
        default: ''
    }
})

const time = computed(() => {
    const now = new Date();
    const targetDate = new Date(props.dateTime);
    return targetDate - now;
})

</script>
<template>
    <vue-countdown
        :time="time"
        :interval="100"
        v-slot="{ days, hours, minutes, seconds }"
    >
        <span>
            <span v-if="days > 0">{{ days }}d</span> <span>{{ hours }}h {{ minutes }}m {{ seconds }}s</span>
            <span v-if="props.suffix">{{ suffix }}</span>
        </span>
    </vue-countdown>
</template>
